import React, { useEffect, useState, useCallback } from 'react'
import { Card, Avatar, Tag } from 'components/ui'
import { HiOutlineUserAdd } from 'react-icons/hi'
import { apiGetRecentMembers } from 'services/MembersService'

const POLL_INTERVAL = 30000

const capitalizeName = (name) => name
  .split(' ')
  .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
  .join(' ')

const NewMembersWelcome = () => {

  const [members, setMembers] = useState([])

  const fetchRecentMembers = useCallback(async () => {
    try {
      const response = await apiGetRecentMembers()
      setMembers(response.data.members)
    } catch (error) {
      // silently ignore, keep showing the last known list
    }
  }, [])

  useEffect(() => {
    fetchRecentMembers()
    const interval = setInterval(fetchRecentMembers, POLL_INTERVAL)
    return () => clearInterval(interval)
  }, [fetchRecentMembers])

  if (!members.length) {
    return null
  }

  return (
    <Card bordered className="mb-4">
      <div className="flex items-center gap-4">
        <Avatar
          className="!bg-transparent !text-emerald-400 border-2 border-emerald-500"
          size={45}
          icon={<HiOutlineUserAdd />}
        />
        <div>
          <h6>Welcome our newest members!</h6>
          <div className="flex flex-wrap gap-2 mt-2">
            {members.map((name, index) => (
              <Tag key={index} className="bg-emerald-100 text-emerald-600 dark:bg-emerald-500/20 dark:text-emerald-100 border-0">
                {capitalizeName(name)}
              </Tag>
            ))}
          </div>
        </div>
      </div>
    </Card>
  )
}

export default NewMembersWelcome
